export default function() {
    const body = document.querySelector('body');
    const mainmenu = document.getElementById('mainmenu');
    // const sidebar = document.getElementById('sidebarinner');

    function setMenu() {
        if (mainmenu.offsetHeight > mainmenu.parentNode.offsetHeight) {
            body.classList.add('mainmenu-scroll');
        } else {
            body.classList.remove('mainmenu-scroll');
        }
    }

    if (mainmenu) {
        setMenu();
        window.addEventListener('resize', setMenu);
    }

    // function setSidebarScroll() {
    //     if (sidebar.offsetHeight > body.offsetHeight - 200) {
    //         body.classList.add('sidebar-scroll');
    //     } else {
    //         body.classList.remove('sidebar-scroll');
    //     }
    // }
    // if (sidebar) {
    //     setSidebarScroll();
    //     window.addEventListener('resize', setSidebarScroll);
    // }
}
